const leadsWidgetValidation = (values, showDetailForm) => {
  const errors = {};
  if (!values.currencyTo) {
    errors.currencyTo = "Please select a to currency.";
  }

  if (!values.currencyFrom) {
    errors.currencyFrom = "Please select a from currency.";
  }

  if (values.currencyTo === values.currencyFrom) {
    errors.currencyTo = "You can't convert to the same currency.";
  }

  if (!showDetailForm) {
    return errors;
  }

  if (!values.email.trim()) {
    errors.email = "Email is required";
  }
  // N.B. This sets maximum TLD to 24 chars
  else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(values.email) ||
    // RFC 5322 Email Regex
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      values.email
    )
  ) {
    errors.email = "Invalid email address";
  }

  if (!values.firstName.trim()) {
    errors.firstName = "First name is required";
  }

  if (!values.lastName.trim()) {
    errors.lastName = "Last name is required";
  }

  if (!values.country) {
    errors.country = "Please select a country";
  }

  if (values.country === "Australia" && !values.state) {
    errors.state = "Please select a state";
  }

  if (!values.phoneCountryCode) {
    errors.phoneCountryCode = "Please select a country code.";
  }

  if (!values.mobileNumber.trim()) {
    errors.mobileNumber = "Mobile number is required";
  } else if (!/^[0-9]+$/i.test(values.mobileNumber)) {
    errors.mobileNumber = "Invalid phone number.";
  } else if (values.mobileNumber.length < 4) {
    errors.mobileNumber =
      "Mobile number must be greater than 4 characters long";
  } else if (values.mobileNumber.length > 15) {
    errors.mobileNumber = "Mobile number must be less than 15 characters long";
  }

  return errors;
};

export default leadsWidgetValidation;
